import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, Typography, Paper, Chip, Stack } from "@mui/material";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import MessageApi from "Services/Message";

const formatDate = (v) => (v ? new Date(v).toLocaleString() : "-");
const toTitle = (v) => (v ? String(v).charAt(0).toUpperCase() + String(v).slice(1) : "-");

const MessageViewModal = ({ openDialog, messageId, handleClose }) => {
  const dispatch = useDispatch();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (!openDialog || !messageId) return;
    dispatch(showLoader("Loading please wait..."));
    MessageApi.getMessageById(messageId).then(
      (res) => {
        dispatch(hideLoader());
        setDetails(res?.data?.data || res?.data || null);
      },
      (err) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: err?.response?.data?.message || "Failed to fetch message details",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "error",
          })
        );
        setDetails(null);
      }
    );
  }, [openDialog, messageId, dispatch]);

  return (
    <Dialog open={openDialog} onClose={() => handleClose(false)} fullWidth maxWidth="md">
      <DialogTitle>Message Details</DialogTitle>
      <DialogContent>
        <Paper elevation={0} sx={{ p: 2, border: "1px solid #e7e7e7", borderRadius: 2, mb: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1.5 }}>Message</Typography>
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6}><Typography variant="body2"><strong>Message ID:</strong> {details?.id || "-"}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography variant="body2"><strong>Conversation ID:</strong> {details?.conversation_id || details?.conversations?.id || "-"}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography variant="body2"><strong>Sender:</strong> {`${details?.users?.first_name || ""} ${details?.users?.last_name || ""}`.trim() || details?.sender_id || "-"}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography variant="body2"><strong>Read At:</strong> {formatDate(details?.read_at)}</Typography></Grid>
            <Grid item xs={12}><Typography variant="body2"><strong>Body:</strong> {details?.body || "-"}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography variant="body2"><strong>Created At:</strong> {formatDate(details?.created_at)}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography variant="body2"><strong>System Message:</strong> {details?.is_system_message ? "Yes" : "No"}</Typography></Grid>
          </Grid>
        </Paper>

        <Paper elevation={0} sx={{ p: 2, border: "1px solid #e7e7e7", borderRadius: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1.5 }}>Related Conversation</Typography>
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6}><Typography variant="body2"><strong>Booking ID:</strong> {details?.conversations?.booking_id || details?.conversations?.bookings?.id || "-"}</Typography></Grid>
            <Grid item xs={12} sm={6}><Typography variant="body2"><strong>Ride ID:</strong> {details?.conversations?.ride_id || details?.conversations?.rides?.id || "-"}</Typography></Grid>
            <Grid item xs={12} sm={6}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body2"><strong>Booking Status:</strong></Typography>
                <Chip size="small" label={toTitle(details?.conversations?.bookings?.status)} />
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body2"><strong>Ride Status:</strong></Typography>
                <Chip size="small" label={toTitle(details?.conversations?.rides?.status)} />
              </Stack>
            </Grid>
          </Grid>
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default MessageViewModal;
